import { forwardRef } from 'react';
import styled from '@emotion/styled';
import type { DropdownProps } from '@hotjar/hotsauce';
import { Dropdown } from '@hotjar/hotsauce';

const StyledDropdown = styled(Dropdown)`
  padding: 0;
  list-style: none;
  width: 200px;

  /* TODO: Remove this override when insights styles are deprecated */
  .tippy-content {
    padding: 0;
  }
`;

export const NavDropdown = forwardRef<HTMLElement, DropdownProps>(
  ({ children, ...props }: DropdownProps, ref): JSX.Element => (
    <StyledDropdown {...props} ref={ref}>
      {children}
    </StyledDropdown>
  ),
);

NavDropdown.displayName = 'NavDropdown';
